import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { MyTasksWidgetKPIOptions } from '@/modules/tasks/taskboard/constants';
import { getKpiMessage } from '@/modules/tasks/taskKpiMessages';
import classNames from 'classnames';
import DashboardTile from './DashboardTile';
export var getKpiStyle = function (kpi, value) {
    var cursor = 'pointer';
    if (!value || value <= 0)
        return { backgroundColor: '#F2F2F2', border: ' 2px solid #F2F2F2', cursor: cursor };
    // Not 0
    switch (kpi) {
        case MyTasksWidgetKPIOptions.pastDeadline:
        case MyTasksWidgetKPIOptions.executionDateBeforeThisWeek:
            return { backgroundColor: 'rgba(184, 0, 22, 0.1)', border: '2px solid #B80016', cursor: cursor };
        case MyTasksWidgetKPIOptions.deadlineOneWeek:
        case MyTasksWidgetKPIOptions.executionDateThisWeek:
            return { backgroundColor: 'rgb(217, 147, 35, 0.1)', border: '2px solid #D99323', cursor: cursor };
        case MyTasksWidgetKPIOptions.deadlineTwoWeeks:
        case MyTasksWidgetKPIOptions.deadlineThreeWeeks:
        case MyTasksWidgetKPIOptions.executionDateNextWeek:
        case MyTasksWidgetKPIOptions.executionDateInTwoWeeks:
        case MyTasksWidgetKPIOptions.executionDateInThreeWeeks:
            return { backgroundColor: '#F2F2F2', border: ' 2px solid #F2F2F2', cursor: cursor };
        default:
            return { backgroundColor: '#F2F2F2', border: ' 2px solid #F2F2F2', cursor: cursor };
    }
};
var DashboardTaskKpiTile = function (_a) {
    var kpi = _a.kpi, _b = _a.value, value = _b === void 0 ? 0 : _b, className = _a.className, onClick = _a.onClick;
    var title = getKpiMessage(kpi);
    var style = useMemo(function () { return getKpiStyle(kpi, value); }, [kpi, value]);
    var handleClick = useCallback(function () {
        onClick(kpi);
    }, [kpi, onClick]);
    return (_jsx(DashboardTile, { title: title, onClick: handleClick, value: value || 0, titleClassName: classNames('task-kpi-title', className), style: style }));
};
export default DashboardTaskKpiTile;
